// src/app/audit/AI/CoPilotV2/components/ConnectionStatus.js

import styled from 'styled-components';

const ConnectionStatus = styled.div`
  padding: 8px 16px;
  background: #fff3cd;
  color: #856404;
  text-align: center;
  font-size: 14px;
  position: sticky;
  top: 0;
  z-index: 1;
`;

export default ConnectionStatus;